import { ApiClient } from './client'

export default class Mail {

  static async sendInquiryForm(form: any, images: File[]) {
    const request = ApiClient.postMultipart('/api/mail-inquiry')

    Object.keys(form).forEach((key) => {
      request.field(key, form[key])
    })

    images.forEach((image) => {
      request.attach('images[]', image)
    })

    return request.then()
  }
}
